import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { RefreshCw } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const StudioOfflineBanner = ({ onBack }) => {
  const [offline, setOffline] = useState(false);
  const wasOffline = useRef(false);
  const backRef = useRef(onBack);
  backRef.current = onBack;

  useEffect(() => {
    let alive = true;
    const check = () => axios.get(`${API}/studio/status`).then((r) => {
      if (!alive) return;
      const off = !r.data.online;
      if (wasOffline.current && !off && backRef.current) backRef.current();
      wasOffline.current = off;
      setOffline(off);
    }).catch(() => {});
    check();
    const t = setInterval(check, 30000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  if (!offline) return null;
  return (
    <div data-testid="studio-offline-banner" role="status"
      className="mb-8 flex items-start gap-3 rounded-2xl border border-[#C5A059]/50 bg-[#2D1037] text-[#FAF7F2] px-5 py-4">
      <RefreshCw size={18} className="text-[#C5A059] mt-0.5 flex-shrink-0 animate-spin [animation-duration:3s]" />
      <div className="text-sm">
        <p className="font-medium">Guides are refreshing, back shortly.</p>
        <p className="text-[#FAF7F2]/70 text-xs mt-0.5">You can keep browsing. Downloads for new purchases may take a little longer to arrive, and this page updates by itself.</p>
      </div>
    </div>
  );
};
